/* SessionContext.tsx generated by @compiled/babel-plugin v3.0.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ouGXIdnbC%7Bmin-width%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39HuIbz8Lp%7Btext-overflow%3Aellipsis%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ANEUSLRg7%7Bwhite-space%3Anowrap%7D");
import React, { type ReactNode } from 'react';
import { Box } from '@atlaskit/primitives/compiled';
const styles = {
  context: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _39HuIbz8Lp _1ANEUSLRg7"
};
export type SessionContextProps = {
  context: ReactNode;
  testId?: string;
};

/** Renders display-ready associated context, such as a Jira issue or Confluence link. */
export const SessionContext = ({
  context,
  testId
}: SessionContextProps): React.JSX.Element | null => {
  if (context === undefined || context === null || context === false) {
    return null;
  }
  return <Box as="span" xcss={styles.context} testId={testId}>
			{context}
		</Box>;
};